export const dates = [
  //fsm - index 0 (not used for netapp)
  {
    startDate: '2025-05-01T00:00:00.000Z',
    endDate: '2026-04-30T23:59:59.999Z',
  },
  //H1 - index 1 (May-Oct)
  {
    startDate: '2026-05-01T00:00:00.000Z',
    endDate: '2026-10-31T23:59:59.999Z',
  },
  //Q1 - index 2 (May-Jul)
  {
    startDate: '2026-05-01T00:00:00.000Z',
    endDate: '2026-07-31T23:59:59.999Z',
  },
  //Q2 - index 3 (Aug-Oct)
  {
    startDate: '2026-08-01T00:00:00.000Z',
    endDate: '2026-10-31T23:59:59.999Z',
  },
  //Q3 - index 4 (Nov-Jan)
  {
    startDate: '2025-11-01T00:00:00.000Z',
    endDate: '2026-01-31T23:59:59.999Z',
  },
  //Q4 - index 5 (Feb-Apr)
  {
    startDate: '2026-02-01T00:00:00.000Z',
    endDate: '2026-04-30T23:59:59.999Z',
  },
  //H2 - index 6 (Nov-Apr)
  {
    startDate: '2025-11-01T00:00:00.000Z',
    endDate: '2026-04-30T23:59:59.999Z',
  },
  //FY (H1-H2) - index 7
  {
    startDate: '2025-05-01T00:00:00.000Z',
    endDate: '2026-04-30T23:59:59.999Z',
  },
];

export const quarter_week: any = {
  0: [
    '2023_W27',
    '2023_W28',
    '2023_W29',
    '2023_W30',
    '2023_W31',
    '2023_W32',
    '2023_W33',
    '2023_W34',
    '2023_W35',
    '2023_W36',
    '2023_W37',
    '2023_W38',
    '2023_W39',
  ],
  1: [
    '2023_W27',
    '2023_W28',
    '2023_W29',
    '2023_W30',
    '2023_W31',
    '2023_W32',
    '2023_W33',
    '2023_W34',
    '2023_W35',
    '2023_W36',
    '2023_W37',
    '2023_W38',
    '2023_W39',
  ],
  2: [
    '2023_W40',
    '2023_W41',
    '2023_W42',
    '2023_W43',
    '2023_W44',
    '2023_W45',
    '2023_W46',
    '2023_W47',
    '2023_W48',
    '2023_W49',
    '2024_W50',
    '2024_W51',
    '2024_W52',
  ],
  3: [
    '2024_W1',
    '2024_W2',
    '2024_W3',
    '2024_W4',
    '2024_W5',
    '2024_W6',
    '2024_W7',
    '2024_W8',
    '2024_W9',
    '2024_W10',
    '2024_W11',
    '2024_W12',
    '2024_W13',
  ],
  4: [
    '2024_W14',
    '2024_W15',
    '2024_W16',
    '2024_W17',
    '2024_W18',
    '2024_W19',
    '2024_W20',
    '2024_W21',
    '2024_W22',
    '2024_W23',
    '2024_W24',
    '2024_W25',
    '2024_W26',
  ],
};

export const maxValList = [
  {
    //at
    fullYearMax: 23.74,
    fullYearMin: 0.0,
    quarterMax: 100,
    quarterMin: 0.92,
  },
  {
    //ca
    fullYearMax: 2.0,
    fullYearMin: 0.0,
    quarterMax: 4.0,
    quarterMin: 1.0,
  },
  {
    //mts
    fullYearMax: 36.75,
    fullYearMin: 0.0,
    quarterMax: 50.67,
    quarterMin: 0.0,
  },
  {
    //med
    fullYearMax: 91.07,
    fullYearMin: 18.75,
    quarterMax: 100.0,
    quarterMin: 18.75,
  },
  {
    //twc
    fullYearMax: 69.3,
    fullYearMin: 5.0,
    quarterMax: 109.25,
    quarterMin: 0.75,
  },
];

export const quartersWithData: any = {
  'Q2 25': true,
  'Q3 25': true,
  'Q4 25': true,
  'Q1 26': true,
  'Q2 26': true,
};

export const outComeDropdownValues = [
  // {
  //   value: 'Quota Attainment',
  //   label: 'Quota Attainment %',
  // },
  {
    value: 'Total Bookings',
    label: 'Bookings (Amount)',
  },
  // {
  //   value: 'Total NACV',
  //   label: 'Total NACV (Amount)',
  // },
  // {
  //   value: 'Renewals',
  //   label: 'Expand ACV (Amount)',
  // },
  // {
  //   value: 'Pipeline Generated',
  //   label: 'Pipeline Generated (Amount)',
  // },
  // {
  //   value: 'Renewals',
  //   label: 'Forecasted Bookings (Amount)',
  // },
  {
    value: 'Deal Size',
    label: 'Deal Size (Amount)',
  },
  // {
  //   value: 'Sales Cycle',
  //   label: 'Sales Cycle (Days)',
  // },
  {
    value: 'Win Rate',
    label: 'Win Rate %',
  },
  {
    value: 'bookings_new_logo',
    label: 'Bookings (New Logo)',
  },
  {
    value: 'Bookings (Expansion/Renewal)',
    label: 'Bookings (Expansion/Renewal)',
  },
];

export const roleName: { [key: string]: string } = {
  ADMIN: 'Admin',
  LEADER: 'Manager',
  AE: 'Rep',
  EXEC: 'Exec',
};

export const personaList = [
  {
    value: 'ADMIN',
    name: 'Admin',
  },
  {
    value: 'LEADER',
    name: 'Manager',
  },
  {
    value: 'AE',
    name: 'Rep',
  },
  {
    value: 'EXEC',
    name: 'Exec',
  },
  {
    value: 'SDR',
    name: 'SDR',
  },
];

export const fiveBubbleLabel: { [key: number]: string } = {
  '0':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">10%</span></div>',
  '1':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">Quartile</span></div>',
  '2':
    '<div><span style="display:flex;justify-content:center">Middle</span><span style="display:flex;justify-content:center;">Performer</span></div>',
  '3':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">Quartile</span></div>',
  '4':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">10%</span></div>',
};

export const threeBubbleLabel: { [key: number]: string } = {
  '0':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">10%</span></div>',
  '1':
    '<div><span style="display:flex;justify-content:center">Middle</span><span style="display:flex;justify-content:center;">Performer</span></div>',
  '2':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">10%</span></div>',
};

export const fourBubbleLabel: { [key: number]: string } = {
  '0':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">10%</span></div>',
  '1':
    '<div><span style="display:flex;justify-content:center">Bottom</span><span style="display:flex;justify-content:center;">Quartile</span></div>',
  '2':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">Quartile</span></div>',
  '3':
    '<div><span style="display:flex;justify-content:center">Top</span><span style="display:flex;justify-content:center;">10%</span></div>',
};

export const fiveBubbleHeaders: { [key: number]: string } = {
  '1': 'Low-Performers',
  '2': 'Below Average - Performers',
  '3': 'Mid-Performers',
  '4': 'High-Performers',
  '5': 'Out-Performers',
};

export const fourBubbleHeaders: { [key: number]: string } = {
  '1': 'Low-Performers',
  '2': 'Mid-Performers',
  '3': 'High-Performers',
  '4': 'Out-Performers',
};
export const threeBubbleHeaders: { [key: number]: string } = {
  '1': 'Low-Performers',
  '2': 'Mid-Performers',
  '3': 'High-Performers',
};

export const percentageDrivers = [
  'Total Connects / Attempts',
  'Future Interest / Connects',
  'Followups / Connects',
  'Meetings Rescheduled / Connects',
];

export const colorCode = [
  { primary: 'rgb(224, 69, 50)', secondary: 'rgb(224  69  50 / 20%)' },
  { primary: 'rgb(242, 113, 69)', secondary: 'rgb(242  113  69 / 20%)' },
  { primary: 'rgb(245, 126, 75)', secondary: 'rgb(245  126  75 / 20%)' },
  { primary: 'rgb(251, 162, 93)', secondary: 'rgb(251  162  93 / 20%)' },
  { primary: 'rgb(166, 217, 111)', secondary: 'rgb(166  217  111 / 20%)' },
  { primary: 'rgb(163, 216, 110)', secondary: 'rgb(163  216  110 / 20%)' },
  { primary: 'rgb(154, 212, 107)', secondary: 'rgb(154  212  107 / 20%)' },
  { primary: 'rgb(156, 213, 108)', secondary: 'rgb(156  213  108 / 20%)' },
  { primary: 'rgb(136, 204, 103)', secondary: 'rgb(136  204  103 / 20%)' },
  { primary: 'rgb(116, 195, 100)', secondary: 'rgb(116  195  100 / 20%)' },
  { primary: 'rgb(128, 200, 102)', secondary: 'rgb(128  200  102 / 20%)' },
  { primary: 'rgb(124, 199, 101)', secondary: 'rgb(124  199  101 / 20%)' },
  { primary: 'rgb(251, 160, 92)', secondary: 'rgb(251  160  92 / 20%)' },
  { primary: 'rgb(15, 130, 68)', secondary: 'rgb(15  130  68 / 20%)' },
  { primary: 'rgb(60, 167, 88)', secondary: 'rgb(60  167  88 / 20%)' },
  { primary: 'rgb(59, 167, 87)', secondary: 'rgb(59  167  87 / 20%)' },
  { primary: 'rgb(69, 173, 90)', secondary: 'rgb(69  173  90 / 20%)' },
  { primary: 'rgb(88, 182, 95)', secondary: 'rgb(88  182  95 / 20%)' },
  {
    primary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(241, 111, 68)"
          ],
          [
              1,
              "rgb(191, 228, 123)"
          ]
      ]
  }`,
    secondary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(241  111  68 / 20%)"
          ],
          [
              1,
              "rgb(191  228  123 / 20%)"
          ]
      ]
  }`,
  },
  {
    primary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(250, 158, 91)"
          ],
          [
              1,
              "rgb(191, 228, 123)"
          ]
      ]
  }`,
    secondary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(250  158  91 / 20%)"
          ],
          [
              1,
              "rgb(191  228  123 / 20%)"
          ]
      ]
  }`,
  },
  {
    primary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(125, 199, 101)"
          ],
          [
              1,
              "rgb(191, 228, 123)"
          ]
      ]
  }`,
    secondary: `{
      "linearGradient": {
          "x1": 0,
          "x2": 1,
          "y1": 0,
          "y2": 0
      },
      "stops": [
          [
              0,
              "rgb(125  199  101 / 20%)"
          ],
          [
              1,
              "rgb(191  228  123 / 20%)"
          ]
      ]
  }`,
  },
  { primary: 'rgb(0, 104, 55)', secondary: 'rgb(0  104  55 / 20%)' },
  { primary: 'rgb(229, 80, 54)', secondary: 'rgb(229  80  54 / 20%)' },
];

export const activeNudges = [
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    action: 'Technical Skills - Advanced',
    primary_driver: 'Technical Skills',
    actionCompleteDate: '2023-05-11T23:16:03.024Z',
    createdDate: '2023-02-11T18:30:00.000Z',
    doneDate: null,
    managerName: 'Leyla',
  },
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    action: 'Meet with Product Teams',
    primary_driver: 'Time with Product team',
    actionCompleteDate: '2023-04-30T05:09:24.294Z',
    createdDate: '2023-01-30T18:30:00.000Z',
    doneDate: null,
    managerName: 'Leyla',
  },
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    action: 'Practice Discovery skills',
    primary_driver: 'Discovery skills',
    actionCompleteDate: '2023-04-13T17:13:11.098Z',
    createdDate: '2023-01-13T18:30:00.000Z',
    doneDate: null,
    managerName: 'Leyla',
  },
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    action: 'Focus on rigor with MEDPICC execution',
    primary_driver: 'MEDPICC score',
    actionCompleteDate: '2023-04-02T23:16:03.024Z',
    createdDate: '2023-01-02T18:30:00.000Z',
    doneDate: null,
    managerName: 'Leyla',
  },
  // {
  //   userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
  //   action: 'Follow up ratio with customer',
  //   primary_driver: 'Follow-up',
  //   actionCompleteDate: '2023-03-27T17:13:11.098Z',
  //   createdDate: '2022-12-27T18:30:00.000Z',
  //   doneDate: null,
  //   managerName: 'Leyla',
  // },
  // {
  //   userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
  //   action: 'Focus on cadence with their Pipeline',
  //   primary_driver: 'Pipeline discipline',
  //   actionCompleteDate: '2023-03-14T23:16:03.024Z',
  //   createdDate: '2022-12-14T18:30:00.000Z',
  //   doneDate: null,
  //   managerName: 'Leyla',
  // },
];

export const json = [
  {
    userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
    activity: 'Practice Consultative skills',
    primary_driver: 'Consultative Skills',
    due_date: '2023-05-26T15:27:26.281Z',
    nudgeDate: '2022-04-04',
    doneDate: '2022-05-04',
    impact: 'Score Increase: 2 >> 4',
    outcome: 'Quota Attainment',
    outcomeTrackerChartData: [
      {
        xAxis: '2022 Q1',
        value: 50,
        nudge: '',
      },
      {
        xAxis: '2022 Q2',
        value: 55,
        nudge: 'DONE DATE',
      },
      {
        xAxis: '2022 Q3',
        value: 65,
        nudge: '',
      },
      {
        xAxis: '2022 Q4',
        value: 65,
        nudge: '',
      },
      {
        xAxis: '2023 Q1',
        value: 72,
        nudge: '',
      },
      {
        xAxis: '2023 Q2',
        value: 78,
        nudge: '',
      },
    ],
  },
  // {
  //   userId: '270dcabb-ccf4-49eb-9e0e-686543208d4b',
  //   activity: 'Multi-thread deals',
  //   primary_driver: 'Time with Customers',
  //   due_date: '2023-05-26T15:27:26.281Z',
  //   nudgeDate: '2022-04-27',
  //   doneDate: '2022-07-27',
  //   impact: 'Time with customers up by 20%',
  //   outcome: 'Deal Size',
  //   outcomeTrackerChartData: [
  //     {
  //       xAxis: '2022 Q1',
  //       value: 55, // $115K
  //       value1: 115,
  //       nudge: '',
  //     },
  //     {
  //       xAxis: '2022 Q2',
  //       value: 55, // $115K
  //       value1: 115,
  //       nudge: '',
  //     },
  //     {
  //       xAxis: '2022 Q3',
  //       value: 60, // $125K
  //       value1: 125,
  //       nudge: 'DONE DATE',
  //     },
  //     {
  //       xAxis: '2022 Q4',
  //       value: 75, // $125K
  //       value1: 150,
  //       nudge: '',
  //     },
  //     {
  //       xAxis: '2023 Q1', // $150K
  //       value: 75,
  //       value1: 150,
  //       nudge: '',
  //     },
  //     {
  //       xAxis: '2023 Q2', // $150K
  //       value: 80,
  //       value1: 165,
  //       nudge: '',
  //     },
  //   ],
  // },
];

export const ryanJuan = {
  battleCard: [
    {
      name: 'Ryan Morgan',
      userId: '005UW000006cZcQYAU',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Agenda',
          value: 1.0,
          valueType: 'discrete',
          original_top_driver: 'Discovery - Next Steps',
          predicted_outcome: '30168.29',
          org_driver_mean_value: 3.0,
          X_poor_org_driver_value: 3.3,
          X_good_org_driver_value: 1.17,
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Purchase Journey',
          value: 1.7,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 1.3,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [
        {
          header:
            'Encourage the team to approach each account and opportunity with more thoughtful engagement',
          actionName: {
            Ryan_ops_1101: {
              agenda: 3,
              purchase_journey: 4,
              intro: 4,
              ops_name: 'Delta Enterprises Cloud Migration',
            },
          },
          course: 'Touch rate per Opp',
          driverDefinition:
            'An overview of what you plan to cover on the call (which is tailored for the customer based on where they are in the purchase journey)',
        },
      ],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 2.11,
      driver2_max_value: 2.59,
      driver3_max_value: 3.64,
      driver1_min_value: 1.9,
      driver2_min_value: 2,
      driver3_min_value: 2.9,
      driver1_mean_value: 1.6,
      driver2_mean_value: 2.11,
      driver3_mean_value: 2.61,
      org_driver_max_value: 1.67,
      org_driver_min_value: 1.17,
    },
    {
      name: 'Juan Carlos Forero',
      userId: '0055f000008bQ2QAAU',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Agenda',
          value: 1.7,
          valueType: 'discrete',
          original_top_driver: 'Touch rate per Opp',
          predicted_outcome: '30168.29',
          org_driver_mean_value: 1.35,
          X_poor_org_driver_value: 1.67,
          X_good_org_driver_value: 1.17,
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Purchase Journey',
          value: 2.5,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 2.38,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 2.11,
      driver2_max_value: 2.59,
      driver3_max_value: 3.64,
      driver1_min_value: 1.9,
      driver2_min_value: 2,
      driver3_min_value: 2.9,
      driver1_mean_value: 1.6,
      driver2_mean_value: 2.11,
      driver3_mean_value: 2.61,
      org_driver_max_value: 1.67,
      org_driver_min_value: 1.17,
    },
  ],
};

export const juanCharls = {
  battleCard: [
    {
      name: 'Charles Adams',
      userId: '0055f000008bIEvAAM',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Agenda',
          value: 2.1,
          valueType: 'discrete',
          original_top_driver: 'Touch rate per Opp',
          predicted_outcome: '30168.29',
          org_driver_mean_value: 1.35,
          X_poor_org_driver_value: 1.67,
          X_good_org_driver_value: 1.17,
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Purchase Journey',
          value: 2.25,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 2.48,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 2.11,
      driver2_max_value: 2.29,
      driver3_max_value: 3.64,
      driver1_min_value: 1.9,
      driver2_min_value: 2,
      driver3_min_value: 2.9,
      driver1_mean_value: 1.6,
      driver2_mean_value: 2.11,
      driver3_mean_value: 2.61,
      org_driver_max_value: 1.67,
      org_driver_min_value: 1.17,
    },
    {
      name: 'Juan Carlos Forero',
      userId: '0055f000008bQ2QAAU',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Agenda',
          value: 1.7,
          valueType: 'discrete',
          original_top_driver: 'Touch rate per Opp',
          predicted_outcome: '30168.29',
          org_driver_mean_value: 1.35,
          X_poor_org_driver_value: 1.67,
          X_good_org_driver_value: 1.17,
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Purchase Journey',
          value: 2.5,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 2.38,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 2.11,
      driver2_max_value: 2.59,
      driver3_max_value: 3.64,
      driver1_min_value: 1.9,
      driver2_min_value: 2,
      driver3_min_value: 2.9,
      driver1_mean_value: 1.6,
      driver2_mean_value: 2.11,
      driver3_mean_value: 2.61,
      org_driver_max_value: 1.67,
      org_driver_min_value: 1.17,
    },
  ],
};

export const ryanCharles = {
  battleCard: [
    {
      name: 'Ryan Morgan',
      userId: '005UW000006cZcQYAU',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Agenda',
          value: 1.0,
          valueType: 'discrete',
          original_top_driver: 'Discovery - Next Steps',
          predicted_outcome: '30168.29',
          org_driver_mean_value: 3.0,
          X_poor_org_driver_value: 3.3,
          X_good_org_driver_value: 1.17,
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Purchase Journey',
          value: 1.7,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 1.9,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [
        {
          header:
            'Encourage the team to approach each account and opportunity with more thoughtful engagement',
          actionName: {
            Ryan_ops_1101: {
              agenda: 3,
              purchase_journey: 4,
              intro: 4,
              ops_name: 'Delta Enterprises Cloud Migration',
            },
          },
          course: 'Touch rate per Opp',
          driverDefinition:
            'An overview of what you plan to cover on the call (which is tailored for the customer based on where they are in the purchase journey)',
        },
      ],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 2.11,
      driver2_max_value: 2.29,
      driver3_max_value: 3.64,
      driver1_min_value: 1.9,
      driver2_min_value: 2,
      driver3_min_value: 2.9,
      driver1_mean_value: 1.6,
      driver2_mean_value: 2.11,
      driver3_mean_value: 2.61,
      org_driver_max_value: 1.67,
      org_driver_min_value: 1.17,
    },
    {
      name: 'Charles Adams',
      userId: '0055f000008bIEvAAM',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Agenda',
          value: 2.1,
          valueType: 'discrete',
          original_top_driver: 'Touch rate per Opp',
          predicted_outcome: '30168.29',
          org_driver_mean_value: 1.35,
          X_poor_org_driver_value: 1.67,
          X_good_org_driver_value: 1.17,
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Purchase Journey',
          value: 2.25,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 2.48,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 2.11,
      driver2_max_value: 2.29,
      driver3_max_value: 3.64,
      driver1_min_value: 1.9,
      driver2_min_value: 2,
      driver3_min_value: 2.9,
      driver1_mean_value: 1.6,
      driver2_mean_value: 2.11,
      driver3_mean_value: 2.61,
      org_driver_max_value: 1.67,
      org_driver_min_value: 1.17,
    },
  ],
};

export const ryanJuan_pg = {
  battleCard: [
    {
      name: 'Ryan Morgan',
      userId: '005UW000006cZcQYAU',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Discovery',
          value: 1.0,
          valueType: 'discrete',
          driver_corr: 'positive',
          original_top_driver: 'Discovery - Purchase Journey',
          predicted_outcome: '30561.63',
          org_driver_mean_value: 2.11,
          X_poor_org_driver_value: 2,
          X_good_org_driver_value: 2.29,
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 1.2,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Agenda',
          value: 1.0,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        
      ],
      battleCardActions: [
        {
          header:
            'Encourage the team to approach each account and opportunity with more thoughtful engagement',
          actionName: {
            Ryan_ops_1101: {
              purchase_journey: 4,
              agenda: 3,
              discovery: 6,
              ops_name: 'Delta Enterprises Cloud Migration',
            },
          },
          course: 'Touch rate per Opp',
          driverDefinition:
            'For Sales only. Asking the customer where they are in the purchase journey. Are they “just browsing” or are they “actively looking”?',
        },
      ],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 2.29,
      driver2_max_value: 2.21,
      driver3_max_value: 2.48,
      driver1_min_value: 2,
      driver2_min_value: 1.9,
      driver3_min_value: 2.52,
      driver1_mean_value: 2.0,
      driver2_mean_value: 2.07,
      driver3_mean_value: 1.62,
      org_driver_max_value: 2.29,
      org_driver_min_value: 2,
    },
    {
      name: 'Juan Carlos Forero',
      userId: '0055f000008bQ2QAAU',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Discovery',
          value: 2.2,
          valueType: 'discrete',
          driver_corr: 'positive',
          original_top_driver: 'Discovery - Purchase Journey',
          predicted_outcome: '30561.63',
          org_driver_mean_value: 2.11,
          X_poor_org_driver_value: 2,
          X_good_org_driver_value: 2.29,
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 2.1,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Agenda',
          value: 1.7,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 2.29,
      driver2_max_value: 2.21,
      driver3_max_value: 2.48,
      driver1_min_value: 2,
      driver2_min_value: 1.9,
      driver3_min_value: 2.52,
      driver1_mean_value: 2.0,
      driver2_mean_value: 2.07,
      driver3_mean_value: 1.62,
      org_driver_max_value: 2.29,
      org_driver_min_value: 2,
    },
  ],
};

export const juanCharles_pg = {
  battleCard: [
    {
      name: 'Juan Carlos Forero',
      userId: '0055f000008bQ2QAAU',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Discovery',
          value: 2.2,
          valueType: 'discrete',
          driver_corr: 'positive',
          original_top_driver: 'Discovery - Purchase Journey',
          predicted_outcome: '30561.63',
          org_driver_mean_value: 2.11,
          X_poor_org_driver_value: 2,
          X_good_org_driver_value: 2.29,
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 2.1,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Agenda',
          value: 1.7,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 2.29,
      driver2_max_value: 2.21,
      driver3_max_value: 2.48,
      driver1_min_value: 2,
      driver2_min_value: 1.9,
      driver3_min_value: 2.52,
      driver1_mean_value: 2.0,
      driver2_mean_value: 2.07,
      driver3_mean_value: 1.62,
      org_driver_max_value: 2.29,
      org_driver_min_value: 2,
    },
    {
      name: 'Charles Adams',
      userId: '0055f000008bIEvAAM',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Discovery',
          value: 2.3,
          valueType: 'discrete',
          driver_corr: 'positive',
          original_top_driver: 'Discovery - Purchase Journey',
          predicted_outcome: '30561.63',
          org_driver_mean_value: 2.11,
          X_poor_org_driver_value: 2,
          X_good_org_driver_value: 2.29,
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 2.2,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Agenda',
          value: 1.8,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 2.29,
      driver2_max_value: 2.21,
      driver3_max_value: 2.48,
      driver1_min_value: 2,
      driver2_min_value: 1.9,
      driver3_min_value: 2.52,
      driver1_mean_value: 2.0,
      driver2_mean_value: 2.07,
      driver3_mean_value: 1.62,
      org_driver_max_value: 2.29,
      org_driver_min_value: 2,
    },
  ],
};

export const ryanCharles_pg = {
  battleCard: [
    {
      name: 'Ryan Morgan',
      userId: '005UW000006cZcQYAU',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Discovery',
          value: 1.0,
          valueType: 'discrete',
          driver_corr: 'positive',
          original_top_driver: 'Discovery - Purchase Journey',
          predicted_outcome: '30561.63',
          org_driver_mean_value: 2.11,
          X_poor_org_driver_value: 2,
          X_good_org_driver_value: 2.29,
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 1.2,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Agenda',
          value: 1.0,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        
      ],
      battleCardActions: [
        {
          header:
            'Encourage the team to approach each account and opportunity with more thoughtful engagement',
          actionName: {
            Ryan_ops_1101: {
              purchase_journey: 4,
              agenda: 3,
              discovery: 6,
              ops_name: 'Delta Enterprises Cloud Migration',
            },
          },
          course: 'Touch rate per Opp',
          driverDefinition:
            'For Sales only. Asking the customer where they are in the purchase journey. Are they “just browsing” or are they “actively looking”?',
        },
      ],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 2.29,
      driver2_max_value: 2.21,
      driver3_max_value: 2.48,
      driver1_min_value: 2,
      driver2_min_value: 1.9,
      driver3_min_value: 2.52,
      driver1_mean_value: 2.0,
      driver2_mean_value: 2.07,
      driver3_mean_value: 1.62,
      org_driver_max_value: 2.29,
      org_driver_min_value: 2,
    },
    {
      name: 'Charles Adams',
      userId: '0055f000008bIEvAAM',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Discovery',
          value: 2.3,
          valueType: 'discrete',
          driver_corr: 'positive',
          original_top_driver: 'Discovery - Purchase Journey',
          predicted_outcome: '30561.63',
          org_driver_mean_value: 2.11,
          X_poor_org_driver_value: 2,
          X_good_org_driver_value: 2.29,
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 2.2,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Agenda',
          value: 1.8,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 2.29,
      driver2_max_value: 2.21,
      driver3_max_value: 2.48,
      driver1_min_value: 2,
      driver2_min_value: 1.9,
      driver3_min_value: 2.52,
      driver1_mean_value: 2.0,
      driver2_mean_value: 2.07,
      driver3_mean_value: 1.62,
      org_driver_max_value: 2.29,
      org_driver_min_value: 2,
    },
  ],
};

export const valueMapElements: any = {
  objectives: 'Objectives',
  success_measures: 'Success Measures',
  deadlines: 'Deadlines',
  objective_motivation: 'Objective Motivation',
  initiatives: 'Initiatives',
  challenges: 'Challenges',
  cost_of_inaction: 'Cost of Inaction',
  our_impact: 'Our Impact',
  our_proof: 'Our Proof',
  power_level: 'Power Level',
  discovery: 'Discovery',
  role: 'Role',
  disposition: 'Disposition',
  purchase_journey: 'Purchase Journey',
  discovery_scaled: 'Discovery (Scaled)',
  intro: 'Intro',
  agenda: 'Agenda',
  level_setting: 'Level Setting',
  recommendation_evaluation_or_service_process:
    'Rec. Evaluation / Service Process',
  mutual_action_planning: 'Mutual Action Planning',
  next_steps: 'Next Steps',
};

export const discoveryDrivers: any = {
  purchase_journey: 'Purchase Journey',
  intro: 'Intro',
  agenda: 'Agenda',
  level_setting: 'Level-Setting',
  recommendation_evaluation_or_service_process:
    'Recommended Evaluation/Service Process',
  mutual_action_planning: 'Mutual Action Planning',
  next_steps: 'Next Steps',
  discovery: 'Discovery',
  // MEDDICC drivers
  metrics: 'Metrics',
  economic_buyer: 'Economic Buyer',
  decision_criteria: 'Decision Criteria',
  decision_process: 'Decision Process',
  identify_pain: 'Identify Pain',
  champion: 'Champion',
  competition: 'Competition',
};

// Q2 2025 - Total Bookings
/* export const juanCharles_q2 = {
  battleCard: [
    {
      name: 'Charles Adams',
      userId: '0055f000008bIEvAAM',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Apollo - Contacts per Account',
          value: 4.33,
          valueType: 'continuous',
          original_top_driver: 'Apollo - Contacts per Account',
          predicted_outcome: '145250',
          org_driver_mean_value: 26.21,
          X_poor_org_driver_value: 4.33,
          X_good_org_driver_value: 71.4,
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Apollo - Director Contact per Deal',
          value: 3.33,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 1.3,
          valueType: 'discrete',
          driver_corr: 'negative',
        },
      ],
      battleCardActions: [
        {
          header:
            'Focus on improving account penetration and multi-threading',
          actionName: 'Increase the number of contacts engaged per account to improve deal velocity and win rates',
          actionName1: 'Engage more director-level stakeholders in each deal',
          actionName2: 'Improve recommended evaluation/service process discussions',
          driverDefinition:
            'The average number of contacts engaged per account. Higher contact engagement correlates with better deal outcomes and reduced sales cycle time.',
          rec_id: 'charles_q2_rec',
          course: 'Account Penetration & Multi-Threading',
        },
      ],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 71.4,
      driver2_max_value: 21.8,
      driver3_max_value: 5,
      driver1_min_value: 2.91,
      driver2_min_value: 2.33,
      driver3_min_value: 1.3,
      driver1_mean_value: 26.21,
      driver2_mean_value: 9.15,
      driver3_mean_value: 2.65,
      org_driver_max_value: 71.4,
      org_driver_min_value: 2.91,
    },
    {
      name: 'Juan Carlos Forero',
      userId: '0055f000008bQ2QAAU',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Apollo - Contacts per Account',
          value: 71.4,
          valueType: 'continuous',
          original_top_driver: 'Apollo - Contacts per Account',
          predicted_outcome: '230750',
          org_driver_mean_value: 26.21,
          X_poor_org_driver_value: 4.33,
          X_good_org_driver_value: 71.4,
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Apollo - Director Contact per Deal',
          value: 21.8,
          valueType: 'continuous',
          driver_corr: 'negative',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Recommended Evaluation/Service Process',
          value: 1.64,
          valueType: 'discrete',
          driver_corr: 'negative',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 71.4,
      driver2_max_value: 21.8,
      driver3_max_value: 5,
      driver1_min_value: 2.91,
      driver2_min_value: 2.33,
      driver3_min_value: 1.3,
      driver1_mean_value: 26.21,
      driver2_mean_value: 9.15,
      driver3_mean_value: 2.65,
      org_driver_max_value: 71.4,
      org_driver_min_value: 2.91,
    },
  ],
}; */

// Q2 2025 - Pipeline Generated
/* export const juanCharles_q2_pg = {
  battleCard: [
    {
      name: 'Charles Adams',
      userId: '0055f000008bIEvAAM',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Discovery',
          value: 4.98,
          valueType: 'discrete',
          original_top_driver: 'Discovery - Mutual Action Planning',
          predicted_outcome: '145250',
          org_driver_mean_value: 3.64,
          X_poor_org_driver_value: 3.41,
          X_good_org_driver_value: 3.86,
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Mutual Action Planning',
          value: 3.41,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Intro',
          value: 6.9,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [
        {
          header:
            'Focus on improving mutual action planning and discovery conversations',
          actionName: 'Strengthen mutual action planning with customers',
          actionName1: 'Increase discovery depth in initial conversations',
          actionName2: 'Improve intro and context-setting',
          driverDefinition:
            'Establishing clear next steps and mutual commitments with customers',
          rec_id: 'charles_q2_pg_rec',
          course: 'Pipeline Development',
        },
      ],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 7.0,
      driver2_max_value: 5.0,
      driver3_max_value: 7.5,
      driver1_min_value: 4.93,
      driver2_min_value: 3.41,
      driver3_min_value: 5.79,
      driver1_mean_value: 4.96,
      driver2_mean_value: 3.64,
      driver3_mean_value: 6.35,
      org_driver_max_value: 3.86,
      org_driver_min_value: 3.41,
    },
    {
      name: 'Juan Carlos Forero',
      userId: '0055f000008bQ2QAAU',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Discovery',
          value: 4.93,
          valueType: 'discrete',
          driver_corr: 'positive',
          original_top_driver: 'Discovery - Discovery',
          predicted_outcome: '230750',
          org_driver_mean_value: 5.0,
          X_poor_org_driver_value: 4.93,
          X_good_org_driver_value: 4.98,
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Mutual Action Planning',
          value: 3.86,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Intro',
          value: 5.79,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 7.0,
      driver2_max_value: 5.0,
      driver3_max_value: 7.5,
      driver1_min_value: 4.93,
      driver2_min_value: 3.41,
      driver3_min_value: 5.79,
      driver1_mean_value: 4.96,
      driver2_mean_value: 3.64,
      driver3_mean_value: 6.35,
      org_driver_max_value: 4.98,
      org_driver_min_value: 4.93,
    },
  ],
}; */

// Q3 2025 - Total Bookings
/* export const juanCharles_q3 = {
  battleCard: [
    {
      name: 'Juan Carlos Forero',
      userId: '0055f000008bQ2QAAU',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Apollo - Director Contact per Deal',
          value: 7.56,
          valueType: 'continuous',
          original_top_driver: 'Discovery - Purchase Journey',
          predicted_outcome: '66000',
          org_driver_mean_value: 2.63,
          X_poor_org_driver_value: 3.02,
          X_good_org_driver_value: 2.24,
          driver_corr: 'negative',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Discovery',
          value: 5.61,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Next Steps',
          value: 5.94,
          valueType: 'discrete',
          driver_corr: 'negative',
        },
      ],
      battleCardActions: [
        {
          header:
            'Focus on improving multi-threading and discovery depth in deals',
          actionName: 'Increase executive and director-level engagement per deal to improve win rates',
          actionName1: 'Deepen discovery conversations to understand customer pain points',
          actionName2: 'Strengthen next steps and commitment from prospects',
          driverDefinition:
            'The average number of director-level contacts engaged per sales opportunity. Higher engagement at director level correlates with larger deal sizes and better win rates.',
          rec_id: 'juan_q3_rec',
          course: 'Executive Engagement & Multi-Threading',
        },
      ],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 23.33,
      driver2_max_value: 5.97,
      driver3_max_value: 5.95,
      driver1_min_value: 2.91,
      driver2_min_value: 5.61,
      driver3_min_value: 5.94,
      driver1_mean_value: 11.27,
      driver2_mean_value: 5.79,
      driver3_mean_value: 5.94,
      org_driver_max_value: 3.02,
      org_driver_min_value: 2.24,
    },
    {
      name: 'Charles Adams',
      userId: '0055f000008bIEvAAM',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Apollo - Director Contact per Deal',
          value: 23.33,
          valueType: 'continuous',
          original_top_driver: 'Discovery - Purchase Journey',
          predicted_outcome: '241500',
          org_driver_mean_value: 2.63,
          X_poor_org_driver_value: 3.02,
          X_good_org_driver_value: 2.24,
          driver_corr: 'negative',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Discovery',
          value: 5.97,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Next Steps',
          value: 5.95,
          valueType: 'discrete',
          driver_corr: 'negative',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 23.33,
      driver2_max_value: 5.97,
      driver3_max_value: 5.95,
      driver1_min_value: 2.91,
      driver2_min_value: 5.61,
      driver3_min_value: 5.94,
      driver1_mean_value: 11.27,
      driver2_mean_value: 5.79,
      driver3_mean_value: 5.94,
      org_driver_max_value: 3.02,
      org_driver_min_value: 2.24,
    },
  ],
}; */

// Q3 2025 - Pipeline Generated
/* export const juanCharles_q3_pg = {
  battleCard: [
    {
      name: 'Juan Carlos Forero',
      userId: '0055f000008bQ2QAAU',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Discovery',
          value: 5.61,
          valueType: 'discrete',
          driver_corr: 'positive',
          original_top_driver: 'Discovery - Discovery',
          predicted_outcome: '66000',
          org_driver_mean_value: 5.79,
          X_poor_org_driver_value: 5.61,
          X_good_org_driver_value: 5.97,
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Mutual Action Planning',
          value: 4.16,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Intro',
          value: 4.86,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [
        {
          header:
            'Enhance discovery conversations and mutual action planning',
          actionName: 'Deepen discovery conversations with prospects',
          actionName1: 'Improve mutual action planning execution',
          actionName2: 'Strengthen intro and context-setting',
          driverDefinition:
            'Conducting comprehensive discovery to understand customer needs, challenges, and objectives',
          rec_id: 'juan_q3_pg_rec',
          course: 'Discovery Mastery',
        },
      ],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 7.0,
      driver2_max_value: 5.5,
      driver3_max_value: 7.5,
      driver1_min_value: 5.61,
      driver2_min_value: 4.16,
      driver3_min_value: 4.86,
      driver1_mean_value: 5.79,
      driver2_mean_value: 4.34,
      driver3_mean_value: 5.65,
      org_driver_max_value: 5.97,
      org_driver_min_value: 5.61,
    },
    {
      name: 'Charles Adams',
      userId: '0055f000008bIEvAAM',
      battleCardData: [
        {
          title: 'Sales Methodology',
          name: 'Discovery - Discovery',
          value: 5.97,
          valueType: 'discrete',
          driver_corr: 'positive',
          original_top_driver: 'Discovery - Discovery',
          predicted_outcome: '241500',
          org_driver_mean_value: 5.79,
          X_poor_org_driver_value: 5.61,
          X_good_org_driver_value: 5.97,
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Mutual Action Planning',
          value: 4.52,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
        {
          title: 'Sales Methodology',
          name: 'Discovery - Intro',
          value: 6.44,
          valueType: 'discrete',
          driver_corr: 'positive',
        },
      ],
      battleCardActions: [],
      title: 'Activity',
      battleCardType: 'Battlecards',
      driver1_max_value: 7.0,
      driver2_max_value: 5.5,
      driver3_max_value: 7.5,
      driver1_min_value: 5.61,
      driver2_min_value: 4.16,
      driver3_min_value: 4.86,
      driver1_mean_value: 5.79,
      driver2_mean_value: 4.34,
      driver3_mean_value: 5.65,
      org_driver_max_value: 5.97,
      org_driver_min_value: 5.61,
    },
  ],
}; */
